import React from "react"
import Header from "../components/Global/Header/Header"
import Footer from "../components/Global/Footer/Footer"

const Layout = ({ children }) => {
  return (
    <div className="layout--container bg-white">
      {/* Skip to Content Link */}
      <a href="#main" className="skip-to-content">
        Skip to content
      </a>

      <Header />
      <main className="max-w-container" id="main">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
